<template>
  <header id="ms_header_downside">
    <div id="header_main">
      <ul class="ms_hddw_nav">
        <li class="corp_logo" v-if="!isMenu">
          <img :src="getImage('common/logo_domans.svg')" width="140px" height="70px" />
        </li>
        <li class="menu_toggle" v-else-if="isMenu">
          <!-- <div class="toggle" @click="onMenu()" @mouseover="isOnMenu=true" @mouseout="isOnMenu=false"> <span></span> <span></span> <span></span> <span class="small_p">menu</span> </div> -->
          <div class="toggle" @click="onMenu()" @mouseover="isOnMenu=true" @mouseout="isOnMenu=false"> <span></span> <span></span> <span></span> <span class="small_p">menu</span> </div>
          <!-- <nav id="main_nav" v-bind:class="{active: isMenuActive}" @mouseover="isOnMenu=true" @mouseout="isOnMenu=false"> -->
          <nav id="main_nav" v-bind:class="{active: isMenuActive}" @mouseover="isOnMenu=true" @mouseout="isOnMenu=false">
            <dd-menu></dd-menu>
          </nav>
        </li>
        <li class="corp_logo" v-else>
        </li>
        <li class="profit_header" v-if="isMenu">
            <div class="profit_disp" style="color: #CC0000;" v-if="isDcPriceDisp">卸価格が表示されています</div>
        </li>
        <li id="system_logo">
          <img :src="getImage('common/logo.png')" width="120px" height="auto" class="link_logo" @click="onLogo()"/>
          <label>My size, My lifestyle.</label>
        </li>
        <li id="sub_content">
          <ul>
            <li id="mail" v-if="isDispSupport">
              <router-link to="/mmstyle/support/input">
                <img :src="getImage('login/icon_mail.svg')" width="40px" height="auto" />
                <label>お問い合せ</label>
              </router-link>
            </li>
            <li  id="call" v-if="isDispTelIcon">
              <img :src="getImage('login/icon_tel.svg')" width="40px" height="auto" />
            </li>
            <li id="tel" v-if="headerTelContentType!=1">
              <label>03-6276-1123</label>
              <label class="small">（平日 10:00～18:00）</label>
            </li>
            <li id="cart" v-if="isCart">
              <router-link to="/mmstyle/cart">
                <img :src="dispCartImg" width="40px" height="auto" />
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </header>
</template>
<script>
import * as App from '../../../utils/App'
import {mapActions, mapState} from 'vuex'
import {PAYMENT_STATUS} from '../../../constants/Type'
import DDMenu from '../../components/top/Menu'
import {DC_STORAGE_KEY} from '../../../constants/App'

export default {
  components: {
    'dd-menu': DDMenu
  },
  props: {
    headerType: {
      type: Number,
      default: 0
    },
    headerSubContentType: {
      type: Number,
      default: 0
    },
    headerTelContentType: {
      type: Number,
      default: 0
    },
    isDcPriceDisp: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isMenuActive: false,
      isOnMenu: false
    }
  },
  computed: {
    ...mapState({
      cartData: state => state.cartData
    }),
    isMenu: function () {
      if (this.headerType === 2) return true
      return false
    },
    isCart: function () {
      if (this.headerType === 2 && this.isLogin) return true
      return false
    },
    isLogin: function () {
      return (this.user.userId !== undefined)
    },
    isDispSupport: function () {
      return this.headerTelContentType === 0
    },
    isDispTelIcon: function () {
      return this.headerTelContentType === 0
    },
    nowList: function () {
      if (!this.cartData || Object.keys(this.cartData).length <= 0) return {}
      return this.cartData.cartList.filter(c => c.status === PAYMENT_STATUS.SAVE_CART.code)
    },
    dispCartImg: function () {
      if (this.nowList.length <= 0) {
        return this.getImage('common/icon_cart.svg')
      } else {
        return this.getImage('common/icon_cart_badge.svg')
      }
    }
  },
  methods: {
    ...mapActions({ getCartData: 'loadCartData' }),
    onMenu: function () {
      if (this.isMenuActive) {
        this.isMenuActive = false
      } else {
        this.isMenuActive = true
      }
    },
    close: function () {
      if (this.isOnMenu || !this.isMenuActive) return
      this.isMenuActive = false
    },
    onLogo: function () {
      if (this.isLogin) {
        this.$router.push({
          name: 'DcTop'
        })
      } else {
        this.$router.push({
          name: 'DcLogin'
        })
      }
    },
    getImage: function (image) {
      return App.getMmstyleResource(image)
    }
  },
  mounted: function () {
  },
  created: function () {
    this.user = App.getLocalStorage(DC_STORAGE_KEY.USER_INFO)
    if (this.isLogin) {
      this.$store.dispatch('loadCartData', {reload: true})
    }
  }
}
</script>
<style src="../../css/style.scss" lang="scss" scoped></style>
<style src="../../css/header.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/components/common/Header.vue